import { createAction, props } from '@ngrx/store';
import { DatosGenerales } from '../../Models/datosGenerales';
import { LeadResponse } from '../../Models/leadResponse';

export const loadCotizacion = createAction('loadCotizacion', props<{ data: DatosGenerales }>());

export const updateResponse = createAction('loadLeadResponse', props<{ leadR: LeadResponse }>());

export const setData = createAction(
  '[General] Set Data',
  props<{ key: string; value: any; merge: boolean }>(),
);
